import { INotification } from "infrastructure/notification";
import { IPickerSearchCriterion } from "ui/screens/security/shared/picker";

export interface IAccount {
  accountId: string;
  accountName: string;
  isPlex?: boolean;
}

export interface IAccountSearchCriterion extends IPickerSearchCriterion<IAccount> {
  tenantId?: string;
  securityRoleId?: string;
}

export interface IAccountsState {
  [x: string]: IAccountsList;
}

export interface IAccountsList {
  items: IAccount[];
  isLoading: boolean;
  notification?: INotification;
}

export const getInitialAccountsState = (): IAccountsState => {
  return {};
};
